import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=5a4e7e7a&scoped=true&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceHeader.vue?vue&type=style&index=0&id=5a4e7e7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e7e7a",
  null
  
)

export default component.exports